<template>
  <transition name="fade">
    <div class="vote-view-container">
      <div class="vote-view-container-content">
        <div class="prompt-container">
          {{ voteResultInfo.promptText }}
        </div>
        <div
          class="score-effects-container"
        >
          <transition name="pop-from-top">
            <div
              v-if="voteResultInfo.resultMsg.length > 0"
              class="score-effect-no-answer"
            >
              {{ voteResultInfo.resultMsg }}
            </div>
          </transition>
          <transition name="pop-from-top">
            <div
              v-if="voteResultInfo.scoreEffects.scoreEffectTeamPlayer"
              class="score-effect-team-player"
            >
              Team Player! Points Doubled
            </div>
          </transition>
          <transition name="pop-from-top">
            <div
              v-if="voteResultInfo.scoreEffects.scoreEffectEvenSplit"
              class="score-effect-even-split"
            >
              Even Split! Points Halved
            </div>
          </transition>
          <transition name="pop-from-top">
            <div
              v-if="voteResultInfo.scoreEffects.scoreEffectGreatMinds"
              class="score-effect-great-minds"
            >
              Great Minds!
            </div>
          </transition>
        </div>
        <div
          class="answer-container"
        >
          <div
            class="answer-container-content"
          >
            <transition name="pop-from-top">
              <div
                class="answer-item"
              >
                <div class="username-item" :style="{ backgroundColor: voteResultInfo.answers[0].primaryColor }">
                  {{ voteResultInfo.answers[0].username }}
                </div>
                <div
                  v-if="voteResultInfo.answers[0].replyType === 'text' || !voteResultInfo.answers[0].wasSubmitted"
                  class="text-item"
                >
                  <span
                    :class="[{ 'no-answer-item': !voteResultInfo.answers[0].wasSubmitted }]"
                  >
                    {{ voteResultInfo.answers[0].wasSubmitted ? voteResultInfo.answers[0].answerText : 'No answer!' }}
                  </span>
                </div>
                <div
                  v-else
                  class="gif-item"
                >
                  <video
                    v-if="!isSafari"
                    class="answer-result-img"
                    :src="voteResultInfo.answers[0].answerHighResMp4Url"
                    muted
                    autoplay
                    loop
                    playsinline
                  >
                  </video>
                  <img
                    v-if="isSafari"
                    class="answer-result-img lazyload"
                    :src="voteResultInfo.answers[0].answerLowResGifUrl"
                    :data-src="voteResultInfo.answers[0].answerHighResGifUrl"
                  />
                </div>
                <div class="vote-item">
                  {{ voteResultInfo.answers[0].numVotes }} {{ voteResultInfo.answers[0].numVotes === 1 ? 'vote' : 'votes' }}
                </div>
                <div class="point-item">
                  {{ voteResultInfo.answers[0].score }} points
                </div>
                <transition name="pop-from-top">
                  <div
                    class="winner-crown-left"
                    v-if="voteResultInfo.answers[0].score > voteResultInfo.answers[1].score"
                  >
                    <font-awesome-icon :icon="['fas', 'crown']" />
                  </div>
                </transition>
              </div>
            </transition>
            <transition name="pop-from-top">
              <div
                class="answer-item"
              >
                <div class="username-item" :style="{ backgroundColor: voteResultInfo.answers[1].primaryColor }">
                  {{ voteResultInfo.answers[1].username }}
                </div>
                <div
                  v-if="voteResultInfo.answers[1].replyType === 'text' || !voteResultInfo.answers[1].wasSubmitted"
                  class="text-item"
                >
                  <span
                    :class="[{ 'no-answer-item': !voteResultInfo.answers[1].wasSubmitted }]"
                  >
                    {{ voteResultInfo.answers[1].wasSubmitted ? voteResultInfo.answers[1].answerText : 'No answer!' }}
                  </span>
                </div>
                <div
                  v-else
                  class="gif-item"
                >
                  <video
                    v-if="!isSafari"
                    class="answer-result-img"
                    :src="voteResultInfo.answers[1].answerHighResMp4Url"
                    muted
                    autoplay
                    loop
                    playsinline
                  >
                  </video>
                  <img
                    v-if="isSafari"
                    class="answer-result-img lazyload"
                    :src="voteResultInfo.answers[1].answerLowResGifUrl"
                    :data-src="voteResultInfo.answers[1].answerHighResGifUrl"
                  />
                </div>
                <div class="vote-item">
                  {{ voteResultInfo.answers[1].numVotes }} {{ voteResultInfo.answers[1].numVotes === 1 ? 'vote' : 'votes' }}
                </div>
                <div class="point-item">
                  {{ voteResultInfo.answers[1].score }} points
                </div>
                <transition name="pop-from-top">
                  <div
                    class="winner-crown-right"
                    v-if="voteResultInfo.answers[1].score > voteResultInfo.answers[0].score"
                  >
                    <font-awesome-icon :icon="['fas', 'crown']" />
                  </div>
                </transition>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'VoteResultView',
  props: {
    voteResultInfo: Object,
    isSafari: Boolean
  },
  mounted: function() {
    this.$emit('play-sound-effect', 'vote-result-reveal');
  }
})
</script>

<style scoped lang="scss">
.answer-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 2%;
  margin: 5%;
  border: 0.1em solid $brand-teal;
  border-radius: 0.4em;
  text-align: center;
  background-color: $natural-white;
  box-shadow: 0 6px 8px -4px black;
}

.username-item {
  flex: 0;
  border-radius: 0.2em;
  padding: 0.4em 1em;
  background-color: $brand-gold;
  text-shadow: 0 0 8px $natural-white;
}

.text-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  padding: 3em 0.5em;
  margin: 0.5em;
  border-radius: 0.2em;
  word-break: break-word;
}

.gif-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.6em;
  border-radius: 0.2em;
}

.no-answer-item {
  padding: 0.4em 0.8em;
  background-color: $baby-blue;
  border-radius: 0.2em;
}

.vote-item {
  flex: 0;
  padding: 0.4em 1em;
  border-radius: 0.2em;
}

.point-item {
  flex: 0;
  padding: 0.4em 1em;
  border-radius: 0.2em;
  background-color: $baby-blue;
  text-shadow: 0 0 8px $natural-white;
}

.winner-crown-left {
  font-size: 3em;
  position: absolute;
  top: -0.6em;
  left: -0.4em;
  color: $brand-gold;
  transform: rotateZ(-30deg);
}

.winner-crown-right {
  font-size: 3em;
  position: absolute;
  top: -0.6em;
  right: -0.4em;
  color: $brand-gold;
  transform: rotateZ(30deg);
}

.score-effects-container {
  flex: 0;
  font-size: 1.4em;
  display: flex;
  margin: 1.6em auto 0;
}

.score-effect-team-player {
  flex: 0;
  width: max-content;
  height: max-content;
  margin: 0 0.4em;
  border-radius: 0.4em;
  padding: 0.6em 1em;
  background-color: $pastel-purple;
  white-space: nowrap;
  animation: change-brightness 2s ease-in-out infinite;
}

.score-effect-even-split {
  flex: 0;
  width: max-content;
  height: max-content;
  margin: 0 0.4em;
  border-radius: 0.4em;
  padding: 0.6em 1em;
  background-color: $coral;
  white-space: nowrap;
  animation: change-brightness 2s ease-in-out infinite;
}

.score-effect-great-minds {
  flex: 0;
  width: max-content;
  height: max-content;
  margin: 0 0.4em;
  border-radius: 0.4em;
  padding: 0.6em 1em;
  background-color: $pastel-green;
  white-space: nowrap;
  animation: change-brightness 2s ease-in-out infinite;
}

.score-effect-no-answer {
  flex: 0;
  width: max-content;
  height: max-content;
  margin: 0 0.4em;
  border-radius: 0.4em;
  padding: 0.6em 1em;
  color: $natural-white;
  background-color: $pantone-blue;
  white-space: nowrap;
  animation: change-brightness 2s ease-in-out infinite;
}

.answer-result-img {
  max-height: 10em;
  max-width: 100%;
  margin: 0.2em 0px;
  width: 16em;
  height: auto;
  object-fit: contain;
  transition: transform 200ms ease-out;
}
</style>
